import autoTable from "jspdf-autotable";

import {
  PDF_TABLE_STYLE,
  PDFCOLORSHEME,
} from "../../../../../component/constent";

const format = (value) => {
  return Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const monthName = (month) => {
  const months = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];

  const value = Number(month);

  return value >= 1 && value <= 12
    ? months[value - 1]
    : String(month || "");
};

export function drawFinancialTable(doc, rows = []) {



 const firstRow = rows?.[0] || {};
  const lastRow = rows?.[rows.length - 1] || {};

  const firstMonth = monthName(firstRow.PMONTH);
  const firstYear = firstRow.PYEAR || "";

  const lastMonth = monthName(lastRow.PMONTH);
  const lastYear = lastRow.PYEAR || "";

  const period =
    firstMonth && lastMonth
      ? `${firstMonth} ${firstYear} - ${lastMonth} ${lastYear}`
      : "";

  const pageWidth = doc.internal.pageSize.getWidth();

  // Main title
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.setTextColor(0);

  doc.text(
    "Financial Appraisal Data for MWS , Gorakhpur",
    pageWidth / 2,
    14,
    {
      align: "center",
    }
  );

  // Figure in Thousands
  doc.setFontSize(10);

  doc.text(
    "(Figure in Thousands)",
    pageWidth / 2,
    20,
    {
      align: "center",
    }
  );

  // Period
  doc.setFontSize(10);

  doc.text(
    `Period: ${period}`,
    pageWidth / 2,
    26,
    {
      align: "center",
    }
  );

  // ==========================================
  // TABLE
  // ==========================================

  //let startY = 32;






  let startY = doc.lastAutoTable
    ? doc.lastAutoTable.finalY + 10
    : 32;

  const totals = rows.reduce(
    (acc, row) => {
      acc.Labour += Number(row.Labour || 0);
      acc.store += Number(row.store || 0);
      acc.freight += Number(row.freight || 0);
      acc.proforma += Number(row.proforma || 0);
      acc.revenue += Number(row.revenue || 0);
      acc.POH += Number(row.POH || 0);
      acc.DRR += Number(row.DRR || 0);
      acc.ReturnStore += Number(row.ReturnStore || 0);
      acc.Electrical += Number(row.Electrical || 0);
      acc.BulkOrder += Number(row.BulkOrder || 0);

      return acc;
    },
    {
      Labour: 0,
      store: 0,
      freight: 0,
      proforma: 0,
      revenue: 0,
      POH: 0,
      DRR: 0,
      ReturnStore: 0,
      Electrical: 0,
      BulkOrder: 0,
    }
  );

  // ==========================================
  // NEW TOTAL AFTER BULK ORDER ADJUSTMENT
  // ==========================================

  const newRevenue =
    totals.revenue - totals.BulkOrder;

  const newPOH =
    totals.POH + totals.BulkOrder;

  autoTable(doc, {
    startY,

    ...PDF_TABLE_STYLE,

    head: [
      [
        "Month",
        "Labour",
        "Store",
        "Freight",
        "Proforma",
        "Revenue",
        "POH",
        "DRR",
        "Return Store",
        "Electrical",
        "Bulk Order",
      ],
    ],

    body: rows.map((row) => [
      `${monthName(row.PMONTH)} ${row.PYEAR || ""}`.trim(),

      format(row.Labour),
      format(row.store),
      format(row.freight),
      format(row.proforma),
      format(row.revenue),
      format(row.POH),
      format(row.DRR),
      format(row.ReturnStore),
      format(row.Electrical),
      format(row.BulkOrder),
    ]),

    // ==========================================
    // NORMAL TOTAL
    // ==========================================

    foot: [
      [
        "TOTAL",
        format(totals.Labour),
        format(totals.store),
        format(totals.freight),
        format(totals.proforma),
        format(totals.revenue),
        format(totals.POH),
        format(totals.DRR),
        format(totals.ReturnStore),
        format(totals.Electrical),
        format(totals.BulkOrder),
      ],
    ],

    styles: {
      fontSize: PDFCOLORSHEME.FONT_SIZE_BODY,
      halign: "right",
      valign: "middle",
    },

    headStyles: {
      fillColor: PDFCOLORSHEME.BACK_COLOR_HEADER,
      textColor: PDFCOLORSHEME.FONT_COLOR_HEADER,
      halign: "center",
      valign: "middle",
      fontStyle: "bold",
    },

    footStyles: {
      fillColor: PDFCOLORSHEME.BACK_COLOR_TOTAL,
      textColor: PDFCOLORSHEME.FONT_COLOR_TOTAL,
      fontStyle: "bold",
      halign: "right",
    },

    columnStyles: {
      0: { cellWidth: 23, halign: "center" },
      1: { cellWidth: 24 },
      2: { cellWidth: 24 },
      3: { cellWidth: 20 },
      4: { cellWidth: 22 },
      5: { cellWidth: 25 },
      6: { cellWidth: 24 },
      7: { cellWidth: 20 },
      8: { cellWidth: 28 },
      9: { cellWidth: 25 },
      10: { cellWidth: 25 },
    },

    margin: {
      left: 10,
      right: 10,
    },
  });

  // ==================================================
  // BULK ORDER ADJUSTMENT + NEW TOTAL
  // ==================================================

  let y = doc.lastAutoTable.finalY + 2;

  const rowHeight = 7;

  // ------------------------------------------
  // BULK ORDER ADJUSTMENT
  // ------------------------------------------

  doc.setFillColor(245, 245, 245);
  doc.rect(10, y, 277, rowHeight, "F");

  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  doc.setTextColor(0);

  doc.text(
    "Bulk Order Adjustment",
    20,
    y + 4.5
  );

  // Revenue - Bulk Order
  doc.text(
    `-${format(totals.BulkOrder)}`,
    145,
    y + 4.5,
    {
      align: "right",
    }
  );

  // POH + Bulk Order
  doc.text(
    `+${format(totals.BulkOrder)}`,
    170,
    y + 4.5,
    {
      align: "right",
    }
  );

  y += rowHeight + 1;

  // ------------------------------------------
  // NEW TOTAL
  // ------------------------------------------

  doc.setFillColor(
    PDFCOLORSHEME.BACK_COLOR_TOTAL
  );

  doc.rect(
    10,
    y,
    260,
    rowHeight,
    "F"
  );

  doc.setTextColor(
    PDFCOLORSHEME.FONT_COLOR_TOTAL
  );

  doc.setFont("helvetica", "bold");
  doc.setFontSize(
    PDFCOLORSHEME.FONT_SIZE_TOTAL
  );

  // Label
  doc.text(
    "NEW TOTAL",
    12,
    y + 4.5
  );

  // Labour
  doc.text(
    format(totals.Labour),
    54,
    y + 4.5,
    { align: "right" }
  );

  // Store
  doc.text(
    format(totals.store),
    79,
    y + 4.5,
    { align: "right" }
  );

  // Freight
  doc.text(
    format(totals.freight),
    100,
    y + 4.5,
    { align: "right" }
  );

  // Proforma
  doc.text(
    format(totals.proforma),
    120,
    y + 4.5,
    { align: "right" }
  );

  // NEW REVENUE
  doc.text(
    format(newRevenue),
    145,
    y + 4.5,
    { align: "right" }
  );

  // NEW POH
  doc.text(
    format(newPOH),
    170,
    y + 4.5,
    { align: "right" }
  );

  // DRR
  doc.text(
    format(totals.DRR),
    190,
    y + 4.5,
    { align: "right" }
  );

  // Return Store
  doc.text(
    format(totals.ReturnStore),
    218,
    y + 4.5,
    { align: "right" }
  );

  // Electrical
  doc.text(
    format(totals.Electrical),
    242,
    y + 4.5,
    { align: "right" }
  );

  // Bulk order is already adjusted,
  // so don't show it again in NEW TOTAL.
  doc.lastAutoTable.finalY = y + rowHeight;
}